import { Card, Input, Row, Typography, Button, message } from "antd";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import HTTPClient from "../../../utils/HTTPClient";
import { DomainPurchaseInfo } from "./DomainPurchaseInfo";
import { useTranslation } from "react-i18next";

const DomainPurchase = () => {
    const [search, setSearch] = useState("");
    const [searching, setSearching] = useState(false);
    const [foundDomain, setFoundDomain] = useState(null);
    const { t } = useTranslation();

    const searchDomain = () => {
        setSearching(true);
        HTTPClient.get("/domains/search", { params: { domain: search } })
            .then((res) => {
                setFoundDomain(res.data);
                setSearching(false);
            })
            .catch((e) => {
                const { error_code } = e?.response?.data;
                message.error(t([`errors.${error_code}`, "domains.purchase.not_available"]));
                setSearching(false);
            });
    };

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    return (
        <Row style={{ padding: isLargeScreen ? "20px 50px" : "10px 10px" }}>
            <Row>
                <Typography.Text style={{ fontSize: "36px", fontWeight: "bold" }}>
                    {t("domains.purchase.title")}
                </Typography.Text>
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Typography.Text>{t("domains.purchase.subtitle")}</Typography.Text>
            </Row>
            <Row style={{ width: "100%", marginTop: "10px" }}>
                <Card style={{ width: "100%" }}>
                    <Card.Meta
                        title={
                            <Typography.Text
                                style={{
                                    fontSize: "x-large",
                                    textTransform: "uppercase",
                                }}></Typography.Text>
                        }
                    />
                    <Row style={{ marginTop: "25px" }}>
                        <Input
                            disabled={foundDomain}
                            size="large"
                            placeholder={t("domains.purchase.search_info")}
                            onChange={(e) => setSearch(e.target.value)}
                            value={search}
                        />
                    </Row>
                    <Row style={{ marginTop: "10px", display: "flex", justifyContent: "flex-end" }}>
                        {!foundDomain ? (
                            <Button
                                onClick={() => searchDomain()}
                                type="primary"
                                loading={searching}
                                size="large"
                                style={{
                                    marginTop: "10px",
                                    width: isLargeScreen ? "" : "100%",
                                }}>
                                {t("domains.purchase.search")}
                            </Button>
                        ) : (
                            <Button
                                type="error"
                                onClick={() => setFoundDomain(false)}
                                size="small"
                                style={{
                                    marginTop: "10px",
                                    width: isLargeScreen ? "" : "100%",
                                }}>
                                {t("domains.purchase.delete")}
                            </Button>
                        )}
                    </Row>
                    <Row style={{ marginTop: "25px" }}>
                        <DomainPurchaseInfo
                            foundDomain={foundDomain}
                            setFoundDomain={setFoundDomain}
                        />
                    </Row>
                </Card>
            </Row>
        </Row>
    );
};

export { DomainPurchase };
